"use client"

import Image from "next/image"
import Link from "next/link"
import { usePathname } from "next/navigation"
import LoginBackground from "public/page-background-1.svg"

import { routes } from "@/config/routes"
import { RhythmsLogo } from "@/icons/rhythms-logo"

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()

  // For signin/signup pages, use minimal layout without background
  if (
    pathname === "/auth" ||
    pathname === "/auth/signin" ||
    pathname === "/auth/signup"
  ) {
    return <div className="bg-surface-secondary min-h-screen">{children}</div>
  }

  // Default layout for other auth pages
  return (
    <div className="relative flex min-h-screen w-screen flex-col items-center justify-center py-16">
      <Link href={routes.root} className="mb-12">
        <div className="pointer-events-none absolute top-0 right-0 overflow-hidden">
          <Image src={LoginBackground} alt="" />
        </div>
        <div className="flex gap-4">
          <RhythmsLogo height={55} width={55} className="text-brand" />
          <p className="text-brand flex items-center text-xl font-semibold">
            Rhythms
          </p>
        </div>
      </Link>

      <div className="flex w-full flex-col items-center gap-8 px-6">
        {children}
        {/* <p className="text-sm text-content-tertiary">
          New to Rhythms? Contact{" "}
          <a
            href="mailto:support@rhythms.ai"
            className="text-info hover:underline"
          >
            support@rhythms.ai
          </a>{" "}
          to create your account.
        </p> */}
      </div>
    </div>
  )
}
